import React, { useState, useEffect } from "react";

export default function LineOption(props) {
  const { data, setStateData, productsWithActions, productName } = props;
  const [selectAll, setSelectAll] = useState(false);
  const [canView, setcanView] = useState(false);
  const [canCreate, setcanCreate] = useState(false);
  const [canEdit, setcanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  // desabilitar campos
  const [disableView, setDisableView] = useState(false);

  var thisScreenInActions = productsWithActions.find(
    // (e) => e.screenId === data.id && e.product === productName
    (e) => e.screenId === data.id && e.productId === data.idmainproduct
  );

  // função que chama a função do arquivo anterior para salvar alteração individual do check
  function changeData({ setState, value, can }) {
    setState(value);
    setStateData({ can: can, value: value, screenData: data });
  }

  // atualizar valores de todos da linha
  function changeAll() {
    const newValue = !selectAll;

    changeData({
      setState: setcanView,
      value:
        data.name === "EVENTO" || data.name === "PARTICIPANTES"
          ? true
          : newValue,
      can: "canView",
    });

    changeData({
      setState: setcanCreate,
      value: newValue,
      can: "canCreate",
    });

    changeData({
      setState: setcanEdit,
      value: newValue,
      can: "canEdit",
    });

    changeData({
      setState: setCanDelete,
      value: newValue,
      can: "canDelete",
    });

    setSelectAll(newValue);
  }

  // marcador os states dos checks
  function getScreenData() {
    setcanView(thisScreenInActions?.canView || false);
    setcanCreate(thisScreenInActions?.canCreate || false);
    setcanEdit(thisScreenInActions?.canEdit || false);
    setCanDelete(thisScreenInActions?.canDelete || false);

    if (
      thisScreenInActions?.canView &&
      thisScreenInActions?.canCreate &&
      thisScreenInActions?.canEdit &&
      thisScreenInActions?.canDelete
    ) {
      setSelectAll(true);
    } else setSelectAll(false);
  }

  // executada toda vez que tiver alteração no objeto para atualizar os states de cada check
  useEffect(() => {
    getScreenData();
  }, [thisScreenInActions]);

  // desabilitar e marcar true para opções evento e participantes, pois são defaults do sistema
  useEffect(() => {
    if ((data && data.name === "EVENTO") || data.name === "PARTICIPANTES") {
      changeData({
        setState: setcanView,
        value: true,
        can: "canView",
      });
      setDisableView(true);
    }
  }, []);

  // ocultar as telas de usuario e perfis no produto telas de config
  if (
    productName === "Telas de Configuração" &&
    (data.name === "USUARIOS" || data.name === "PERFIS")
  )
    return null;
  else
    return (
      <>
        <tr>
          <td>{data.screenname}</td>

          <td className="text-center">
            <input
              type="checkbox"
              onChange={(e) => {
                changeData({
                  setState: setcanView,
                  value: e.target.checked,
                  can: "canView",
                });
              }}
              checked={canView || canCreate || canEdit || canDelete}
              disabled={disableView || canCreate || canEdit || canDelete}
            />
          </td>
          <td className="text-center">
            <input
              type="checkbox"
              onChange={(e) => {
                changeData({
                  setState: setcanCreate,
                  value: e.target.checked,
                  can: "canCreate",
                });
              }}
              checked={canCreate}
            />
          </td>
          <td className="text-center">
            <input
              type="checkbox"
              onChange={(e) => {
                changeData({
                  setState: setcanEdit,
                  value: e.target.checked,
                  can: "canEdit",
                });
              }}
              checked={canEdit || canCreate}
              disabled={canCreate}
            />
          </td>
          <td className="text-center">
            <input
              type="checkbox"
              onChange={(e) => {
                changeData({
                  setState: setCanDelete,
                  value: e.target.checked,
                  can: "canDelete",
                });
              }}
              checked={canDelete}
            />
          </td>
          <td className="text-center">
            <input
              type="checkbox"
              checked={canCreate && canView && canEdit && canDelete}
              onClick={() => {
                changeAll();
              }}
            />
          </td>
        </tr>
      </>
    );
}
